import React from "react";
import Click from "./Click/Click";
import FindAndClick from "./FindAndClick/FindAndClick";
import FindAndInput from "./FindAndInput/FindAndInput";
import Scope from "./Scope/Scope";
import GetText from "./GetText/GetText";
import GetImage from "./GetImage/GetImage";
import MouseMove from "./MouseMove/MouseMove";
import Recorder from "./Recorder/Recorder";
import Wait from "./Wait/Wait";
import DoubleClick from "./DoubleClick/DoubleClick";
import KeyPress from "./KeyPress/KeyPress";
import { types } from "./types";
import Hover from "./Hover/Hover";
import Scroll from "./Scroll/Scroll";
import KeyCombination from "./KeyCombination/KeyCombination";

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert -  show alert
 * @param       recorder
 * @param       setRender
 * @param       automId
 * @returns     JSX.Element
 * @author      ibrahim AKIN
 */
function Actions(
    action,
    showAlert,
    variables,
    setOpenVariable,
    recorder,
    setRender,
    automId,
    actions,
    automVersionId
) {
    switch (action.actionName) {
        case types.CAPTURE:
            return (
                <Recorder
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    recorder={recorder}
                    setRender={setRender}
                />
            );
        case types.DRAG:
        case types.CLICK:
            return (
                <Click
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.FCLICK:
            return (
                <FindAndClick
                    actions={actions}
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.FINPUT:
            return (
                <FindAndInput
                    actions={actions}
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.GETTEXT:
            return (
                <GetText
                    actions={actions}
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.GETIMAGE:
            return (
                <GetImage
                    actions={actions}
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.GETIMAGE:
            return (
                <GetImage
                    action={action}
                    actions={actions}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.SCOPE:
            return (
                <Scope
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    automId={automId}
                    automVersionId={automVersionId}
                />
            );
        case types.MOVE:
            return (
                <MouseMove
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.WAIT:
            return (
                <Wait
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.DCLICK:
            return (
                <DoubleClick
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.SUP:
        case types.SDOWN:
            return <Scroll action={action} />
        case types.TAP:
        case types.PRESS:
            return (
                <KeyPress
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.COMBINATION:
            return (
                <KeyCombination
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );
        case types.HOVER:
            return (
                <Hover
                    action={action}
                    actions={actions}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            );

        default:
            break;
    }
}

export default Actions;
